// ============================================
// FILE: src/components/fashion/OptionDropdown.jsx
// ============================================
//
// Dropdown for a product option on the PDP — pack sizes, sizes and any other
// option except colour, which stays a visual swatch row.
//
// A native <select>: desktop shows a list, phones open the OS picker, and
// keyboard / screen-reader support comes for free. Unavailable values stay in
// the list but disabled, so the shopper can see what exists.

import React from 'react';

const OptionDropdown = ({
  id,
  value = null,
  options = [],          // [{ value, label, disabled }]
  onChange = () => {},
  placeholder = null,    // shown while nothing is chosen
  invalid = false,
  ariaLabel,
}) => {
  const current = value === null || value === undefined ? '' : String(value);
  const hasCurrent = options.some((o) => String(o.value) === current);

  return (
    <select
      id={id}
      className="fx-select"
      value={hasCurrent ? current : ''}
      data-empty={!hasCurrent}
      data-invalid={invalid}
      aria-invalid={invalid || undefined}
      aria-label={ariaLabel}
      onChange={(e) => {
        const picked = options.find((o) => String(o.value) === e.target.value);
        if (picked && !picked.disabled) onChange(picked.value);
      }}
    >
      {(placeholder || !hasCurrent) && (
        <option value="" disabled>
          {placeholder || 'Select an option'}
        </option>
      )}
      {options.map((o) => (
        <option key={String(o.value)} value={String(o.value)} disabled={!!o.disabled}>
          {o.label}
        </option>
      ))}
    </select>
  );
};

export default OptionDropdown;
